import { Injectable } from '@angular/core';
import { ISirena } from 'modelosSeguridad/src';

@Injectable({
  providedIn: 'root',
})
export class SirenasService {
  /**
   *
   * @param sirena Sirena de Seguridad
   * @returns estado para elegir en lugares (string)
   */
  public devolverEstado(sirena: ISirena): string {
    // Primero verificar estados específicos/críticos
    if (sirena.errorActualizacion) {
      // Rojo
      return 'Error Actualización';
    }
    if (sirena.actualizando) {
      // Amarillo
      return 'Actualizando';
    }
    if (sirena.sonidoEncendido) {
      // Azul
      return 'Sonido Encendido';
    }
    if (sirena.luzEncendida) {
      // Azul
      return 'Luz Encendida';
    }
    // Luego estados generales
    if (sirena.online && sirena.activa) {
      // Verde
      return 'Activa';
    }
    if (!sirena.activa) {
      // Rojo
      return 'Inactiva';
    }
    return 'Desconocido';
  }

  /**
   * Devuelve el ícono del mapa según el estado de la sirena
   * @param sirena Sirena de Seguridad
   * @returns ruta del ícono para el mapa
   */
  public devolverIconoMapa(sirena: ISirena): string {
    const estado = this.devolverEstado(sirena);

    switch (estado) {
      case 'Activa':
        return 'assets/pins/sirenas/sirena-verde.png'; // Verde - Todo OK
      case 'Actualizando':
        return 'assets/pins/sirenas/sirena-amarilla.png'; // Amarillo - En proceso
      case 'Sonido Encendido':
      case 'Luz Encendida':
        return 'assets/pins/sirenas/sirena-azul.png'; // Azul - Operación activa
      case 'Error Actualización':
      case 'Inactiva':
        return 'assets/pins/sirenas/sirena-naranja.png'; // Naranja - Error/Inactiva
      default:
        return 'assets/pins/sirenas/sirena-naranja.png'; // Naranja por defecto para desconocido
    }
  }

  /**
   * Obtiene el nombre de ícono Material según el estado de la sirena
   * @param estado Estado de la sirena
   * @returns nombre de ícono Material Icons
   */
  public getIconoEstado(estado: string): string {
    switch (estado) {
      case 'Activa':
        return 'check_circle'; // Verde - Todo OK
      case 'Actualizando':
        return 'settings'; // Amarillo - En proceso
      case 'Sonido Encendido':
        return 'volume_up'; // Azul - Sonido activo
      case 'Luz Encendida':
        return 'lightbulb'; // Azul - Luz activa
      case 'Error Actualización':
        return 'warning'; // Naranja - Error
      case 'Inactiva':
        return 'cancel'; // Naranja - Inactiva
      default:
        return 'question_mark'; // Desconocido
    }
  }

  /**
   * Obtiene el color según el estado de la sirena
   * @param estado Estado de la sirena
   * @returns color hexadecimal
   */
  public getColorEstado(estado: string): string {
    switch (estado) {
      case 'Activa':
        return '#4CAF50'; // Verde
      case 'Actualizando':
        return '#FFC107'; // Amarillo
      case 'Sonido Encendido':
      case 'Luz Encendida':
        return '#2196F3'; // Azul
      case 'Error Actualización':
      case 'Inactiva':
        return '#FF5722'; // Naranja/Rojo
      default:
        return '#9E9E9E'; // Gris
    }
  }
}
